import React from "react";
import Header from "../../LandingPage/Header";
import Footer from "../../LandingPage/Footer";
import LanguageSelector from "../../Languages/LanguageSelector";

const DeleteAccount = ({ supportEmail = "info@fetanmarket.com" }) => {
  return (
    <div className="bg-info">
      <div
        className="navbar-expand-lg navbar-light  fixed-top"
        style={{ zIndex: "99999" }}
      >
        <LanguageSelector />
      </div>
      <Header />
      <div
        className="bg-info d-flex justify-content-center align-items-center"
        style={{ paddingTop: "180px", paddingBottom: "70px" }}
      >
        <div
          className="border border-2 border-light mx-auto  p-4  text-center"
          style={{
            maxWidth: "500px",
            paddingTop: "150px",
            backgroundColor: "white",
            height: "100%",
          }}
        >
          <h4 className="mb-3 fs-2 text-light">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            Delete Account
          </h4>
          <p className="mb-3">
            To delete your account, please contact our support team. This action
            is permanent and cannot be undone.
          </p>
          <p className="d-flex justify-content-center align-items-center gap-2">
            <i className="bi bi-envelope-fill"></i> {/* Bootstrap email icon */}
            <a
              href={`mailto:${supportEmail}`}
              className="text-decoration-underline"
            >
              {supportEmail}
            </a>
          </p>
          <p className="text-muted small mt-3">
            Our support team will guide you through the account deletion process
            safely.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DeleteAccount;
